export default "__VITE_ASSET__BN2ld8zS__"